module.exports = __webpack_public_path__ + "img/17_16.d1061969.png";